export enum UserRole {
  EXAM_TAKER = 'ExamTaker',
  ANALYST = 'Analyst',
  CONTRIBUTOR = 'Contributor',
  MANAGER = 'Manager',
  MODERATOR = 'Moderator',
  ADMINISTRATOR = 'Administrator',
};